import config from '#/config'
import { i18n } from '#/locales'

import routes from '#/routes'
import store from '#/stores'
import ui from '@nuxt/ui/vue-plugin'
import { passiveSupport } from 'passive-events-support/src/utils'
import { createApp } from 'vue'
import { registerComponent } from '@/libvue/components/button'
import * as directives from '@/libvue/directives'
import { HelpScoutBeacon } from '@/libvue/plugins/helpscoutBeacon'
import { MetrieGTM } from '@/libvue/plugins/metrieGTM'
import { rcActionStats } from '@/libvue/plugins/statistics/actionStats'
import { rcPageStats } from '@/libvue/plugins/statistics/pageStats'

// plugins
import { toaster } from '@/libvue/plugins/toaster'
import App from './App.vue'
// Styles
import './main.scss'
import './assets/css/main.css'

passiveSupport({
  events: ['touchstart', 'touchmove'],
})

const app = createApp(App)

// Register all custom directives
Object.keys(directives).forEach((d) => {
  app.directive(d, directives[d])
})

registerComponent(app)
app.config.globalProperties.t = i18n.global.t

app
  .use(MetrieGTM, {
    router: routes,
  })
  .use(rcPageStats, { router: routes, stores: store })
  .use(rcActionStats, { router: routes, stores: store })

app
  .use(store)
  .use(routes)
  .use(ui)
  .use(toaster)
  .use(i18n)
  .use(HelpScoutBeacon, {
    router: routes,
    stores: store,
    localeIds: config.helpScout.localeIds,
  })
  .mount('#app')
